import { useEffect } from "react";
import { type BetslipCapabilityExposure } from "../contract";
import { emitCapabilityExposure } from "../contract/betslip-api";

export function useCapabilityExposure(exposure: BetslipCapabilityExposure | null): void {
  useEffect(() => {
    if (!exposure) {
      return;
    }

    emitCapabilityExposure(exposure);
  }, [exposure]);
}
